export default __webpack_public_path__ + "static/media/8-26-89-bowie.a7d9042c.m4a";